import { render, staticRenderFns } from "./userManage.vue?vue&type=template&id=3837efe4&scoped=true"
import script from "./userManage.vue?vue&type=script&lang=js"
export * from "./userManage.vue?vue&type=script&lang=js"
import style0 from "./userManage.vue?vue&type=style&index=0&id=3837efe4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837efe4",
  null
  
)

export default component.exports